import {Component} from "react";
import "./SimulationFlowProgress.css";
import Glob from "../../../libs/Glob.mjs";
import AppSimulationIcon from "../../../media/app-images/AppSimulationIcon.mjs";
import PlayIcon from "../../../media/images/PlayIcon.mjs";

const prefix = 'SimulationFlowProgress';

const SimulationFlowProgress = class extends Component {
	constructor(props) {
		super(props);
		this.renderStep = this.renderStep.bind(this);
	}
	renderStep(step,idx) {
		const status = this.props.status || 0;
		let cn = [];
		const thisIsCurrent = (this.props.step === step.label);
		const thisIsDone = (status >= step.threshold);
		const prevIsDone = ( idx > 0) && ( status >= this.props.steps[idx -1].threshold);
		if ( thisIsCurrent ) cn.push('current');
		cn.push( thisIsDone ? 'done' : 'undone');
		const canClick = (thisIsDone || prevIsDone) && ! thisIsCurrent;
		if ( canClick ) cn.push('clickable');
		const classes = cn.join(' ');
		const out = [];
		if ( idx ) {
			out.push(
				<div className={"spacer "+( prevIsDone ? 'done' : 'undone')} key={'spacer-'+idx}>
					<div />
					<PlayIcon />
				</div>
			);
		}
		out.push(
			<div
				className={"node "+classes} key={'node-'+idx}
				onClick={ canClick ? ()=> { Glob.setCurrentPageParam('step', step.label)} : undefined}
				title={ step.info ? Glob.label( step.info ) : undefined }
			>
				<span>{ step.icon ?? step.label }</span>
			</div> );
		return out;
	}
	render() {
		return (
			<div className={prefix}>
				<div>
					{ this.props.editing && (
						<div
							className={"node pre "+( this.props.step ? 'clickable done' : 'current')}
							onClick={ ()=>{ Glob.rmCurrentPageParam('step') } }
						>
							<AppSimulationIcon />
						</div>
					) }
					{ this.props.steps.map((step, i) => this.renderStep(step, i)) }
				</div>
			</div>
		)
	}
}

export default SimulationFlowProgress;